import React, { useState, useRef } from 'react';
import '../App.css';
import './Button.css'
import emailjs from '@emailjs/browser';

function Contact() {
    const form = useRef();
  const [formData, setFormData] = useState({
    name: '',
    phoneNumber: '',
    email: '',
    message: '',
    referral: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // You need to set up an endpoint where this data should be sent.
    // This example will log the data to the console for demonstration purposes.
    console.log(formData);
    alert('Thanks for reaching out to us! We will be in touch with you soon!');

    emailjs.sendForm('service_i3ienqi', 'template_m5dtpbe', form.current, 'D4mEPNUSlsN-mCJUk')
    .then((result) => {
        console.log(result.text);
    }, (error) => {
        console.log(error.text);
    });

    setFormData({
        name: '',
        phoneNumber: '',
        email: '',
        message: '',
        referral: ''
    })
    
    // In a real application, you'd send a request to your server here.
    // Example (uncomment when you have a server endpoint):
    // await fetch('/api/sendEmail', {
    //   method: 'POST',
    //   headers: {
    //     'Content-Type': 'application/json',
    //   },
    //   body: JSON.stringify(formData),
    // });
  };

  return (
    <div className="App">
      <div className="contact-form">
        <h1>Contact Us</h1>
        <form ref={form} onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Name"
            required
            value={formData.name}
            onChange={handleChange}
          />
          <input
            type="tel"
            name="phoneNumber"
            placeholder="Phone Number"
            required
            value={formData.phoneNumber}
            onChange={handleChange}
          />
          <input
            type="email"
            name="email"
            required
            placeholder="Email Address"
            value={formData.email}
            onChange={handleChange}
          />
          <textarea
            name="message"
            required
            placeholder="Your Message"
            value={formData.message}
            onChange={handleChange}
          />
          <input
            type="text"
            name="referral"
            required
            placeholder="How did you hear about us?"
            value={formData.referral}
            onChange={handleChange}
          />
          <button type="submit">Send</button>
        </form>
      </div>
    </div>
  );
}

export default Contact;
